import React from 'react';
import { Link } from 'react-router-dom';
import { navLinks } from '../mock';
import { Logo } from './Navbar';

const Footer = ({ onDownload }) => {
  return (
    <footer className="bg-[#0b1510] text-white pt-16 pb-10 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-10 border-b border-white/10 pb-12">
          <div className="max-w-sm">
            <div className="text-white mb-4"><Logo className="text-3xl" /></div>
            <p className="text-white/55 text-sm leading-relaxed">
              Turn your phone into a checkout. Accept card payments anywhere, get paid in seconds, and grow with insights built in.
            </p>
            <button onClick={onDownload} className="mt-6 bg-[#0e9f6e] text-white rounded-xl px-6 py-3 text-sm font-semibold hover:bg-[#0c8a60] transition-colors">
              Get FLIX free
            </button>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4">Product</h4>
              <ul className="space-y-3">
                {navLinks.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4">Company</h4>
              <ul className="space-y-3 text-sm text-white/70">
                <li className="hover:text-white cursor-pointer transition-colors">About</li>
                <li className="hover:text-white cursor-pointer transition-colors">Careers</li>
                <li className="hover:text-white cursor-pointer transition-colors">Contact</li>
                <li className="hover:text-white cursor-pointer transition-colors">Support</li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-widest text-white/40 mb-4">Legal</h4>
              <ul className="space-y-3 text-sm text-white/70">
                <li className="hover:text-white cursor-pointer transition-colors">Privacy</li>
                <li className="hover:text-white cursor-pointer transition-colors">Terms</li>
                <li className="hover:text-white cursor-pointer transition-colors">Cookies</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-8">
          <p className="text-white/40 text-xs">© {new Date().getFullYear()} FLIX. All rights reserved. Demo project.</p>
          <p className="text-white/40 text-xs">Built for demonstration purposes only.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
